module.exports = __webpack_public_path__ + "img/icon-arrow-left.44b203d8.svg";